/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {MedicalScreening, MedicalScreeningPeriod, ScreeningStatus} from "@app/app-shared/medical-screening";
import {PatientGender} from "@app/ir-q-app-common/types/care-center/user";

export const demoScreenings: MedicalScreening[] = [
    {
        id: 1,
        name: "Breast Cancer Screening",
        period_gap: 365,
        gender: PatientGender.FEMALE,
        minimum_age: 50,
        maximum_age: 74,
        isEnabled: true,
        currentScreeningStatus: null,
        screeningStatuses: [
            {
                id: 101,
                status: ScreeningStatus.WENT_TO_APPOINTMENT,
                screening_id: 1,
                agent_id: "demo-unit",
                date_made_timestamp: Date.now() - 60 * 24 * 60 * 60 * 1000,
                step_retries: 0,
                last_retry_timestamp: null,
                appointment_date_timestamp: Date.now() - 30 * 24 * 60 * 60 * 1000,
                screening_period_id: 1,
            },
        ],
    },
    {
        id: 2,
        name: "Colorectal Cancer Screening",
        period_gap: 365,
        gender: PatientGender.MALE,
        minimum_age: 45,
        maximum_age: 75,
        isEnabled: true,
        currentScreeningStatus: null,
        screeningStatuses: [
            {
                id: 102,
                status: ScreeningStatus.MADE_APPOINTMENT,
                screening_id: 2,
                agent_id: "demo-unit",
                date_made_timestamp: Date.now() - 14 * 24 * 60 * 60 * 1000,
                step_retries: 1,
                last_retry_timestamp: Date.now() - 7 * 24 * 60 * 60 * 1000,
                appointment_date_timestamp: Date.now() + 7 * 24 * 60 * 60 * 1000,
                screening_period_id: 2,
            },
        ],
    },
    {
        id: 3,
        name: "Diabetic Eye Exam",
        period_gap: 365,
        gender: PatientGender.MALE,
        minimum_age: 18,
        maximum_age: 75,
        isEnabled: true,
        currentScreeningStatus: null,
        screeningStatuses: [
            {
                id: 103,
                status: ScreeningStatus.PROPOSED,
                screening_id: 3,
                agent_id: "demo-unit",
                date_made_timestamp: Date.now() - 3 * 24 * 60 * 60 * 1000,
                step_retries: 0,
                last_retry_timestamp: null,
                appointment_date_timestamp: null,
                screening_period_id: null,
            },
        ],
    },
    {
        id: 4,
        name: "Blood Pressure Control",
        period_gap: 180,
        gender: PatientGender.MALE,
        minimum_age: 18,
        maximum_age: 85,
        isEnabled: false,
        currentScreeningStatus: null,
        screeningStatuses: [
            {
                id: 104,
                status: ScreeningStatus.REJECTED,
                screening_id: 4,
                agent_id: "demo-unit",
                date_made_timestamp: Date.now() - 90 * 24 * 60 * 60 * 1000,
                step_retries: 0,
                last_retry_timestamp: null,
                appointment_date_timestamp: null,
                screening_period_id: null,
            },
        ],
    },
    {
        id: 5,
        name: "Statin Therapy",
        period_gap: 365,
        gender: PatientGender.MALE,
        minimum_age: 40,
        maximum_age: 75,
        isEnabled: true,
        currentScreeningStatus: null,
        screeningStatuses: [
            {
                id: 105,
                status: ScreeningStatus.DONE_BEFORE,
                screening_id: 5,
                agent_id: "demo-unit",
                date_made_timestamp: Date.now() - 120 * 24 * 60 * 60 * 1000,
                step_retries: 0,
                last_retry_timestamp: null,
                appointment_date_timestamp: Date.now() - 100 * 24 * 60 * 60 * 1000,
                screening_period_id: null,
            },
        ],
    },
];

export const demoPeriods: MedicalScreeningPeriod[] = [
    {
        id: 1,
        agent_id: "demo-unit",
        start_date: Date.now() - 90 * 24 * 60 * 60 * 1000,
        primary_screening_id: 1,
        all_screening_ids: [1],
        screening_ordinal: 1,
    },
    {
        id: 2,
        agent_id: "demo-unit",
        start_date: Date.now() - 30 * 24 * 60 * 60 * 1000,
        primary_screening_id: 2,
        all_screening_ids: [2],
        screening_ordinal: 1,
    },
];